export const createImportReducer = (types) => {
  const initialState = {
    loading: false,
    loadingDetail: false,
    loadingExport: false,
    loadingImport: false,
    loadingDownloadTemplate: false,
    error: '',
    listData: [],
    detailListData: [],
    detailData: {},
    pageable: {
      page: 1,
      size: 10,
      totalRecords: 0
    }
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case types.LIST_REQUEST:
        return { ...state, loading: true }
      case types.LIST_SUCCESS:
        return {
          ...state,
          loading: false,
          listData: action.payload,
          pageable: action.pageable ? action.pageable : state.pageable,
          error: ''
        }
      case types.LIST_FAILURE:
        return { ...state, loading: false, error: action.payload }

      case types.DETAIL_LIST_REQUEST:
        return { ...state, loading: true }
      case types.DETAIL_LIST_SUCCESS:
        return {
          ...state,
          loading: false,
          detailListData: action.payload,
          pageable: action.pageable ? action.pageable : state.pageable,
          error: ''
        }
      case types.DETAIL_LIST_FAILURE:
        return { ...state, loading: false, error: action.payload }

      case types.DETAIL_REQUEST:
        return { ...state, loadingDetail: true }
      case types.DETAIL_SUCCESS:
        return {
          ...state,
          loadingDetail: false,
          detailData: action.payload,
          error: ''
        }
      case types.DETAIL_FAILURE:
        return { ...state, loadingDetail: false, error: action.payload }

      case types.EXPORT_REQUEST:
        return { ...state, loadingExport: true }
      case types.EXPORT_SUCCESS:
        return { ...state, loadingExport: false, error: '' }
      case types.EXPORT_FAILURE:
        return { ...state, loadingExport: false, error: action.payload }

      case types.FILE_UPLOAD_REQUEST:
        return { ...state, loadingImport: true }
      case types.FILE_UPLOAD_SUCCESS:
        return { ...state, loadingImport: false, error: '' }
      case types.FILE_UPLOAD_FAILURE:
        return { ...state, loadingImport: false, error: action.payload }

      case types.DOWNLOAD_TEMPLATE_REQUEST:
        return { ...state, loadingDownloadTemplate: true }
      case types.DOWNLOAD_TEMPLATE_SUCCESS:
        return { ...state, loadingDownloadTemplate: false, error: '' }
      case types.DOWNLOAD_TEMPLATE_FAILURE:
        return { ...state, loadingDownloadTemplate: false, error: action.payload }

      default:
        return state
    }
  }
}
